<template>
  <div>
    <label>{{ label }}</label>
    <div
      class="nt-textarea"
      :class="[error ? 'nt-textarea--error':'', getTheme]"
    >
      <textarea
        :id="id"
        v-model.trim="selected"
        :placeholder="placeholder"
        :label="label"
        rows="4"
        :maxlength="maxLength"
        @input="changeForm"
        @blur="validateOnBlur"
      />
    </div>
    <div
      v-if="error"
      class="nt-form-error"
    >
      {{ error }}
    </div>
    <div
      v-if="helperText"
      class="nt-form-text-helper"
    >
      {{ helperText }}
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import emitter from 'tiny-emitter/instance'

export default {
  name: 'nt-textarea',
  props: {
    id: {
      type: String,
      default: 'textarea'
    },
    label: {
      type: String,
      default: null
    },
    placeholder: {
      type: String,
      default: ''
    },
    validators: {
      type: Array,
      default: []
    },
    theme: {
      type: String,
      default: 'default'
    },
    helperText: {
      type: String,
      default: ''
    },
    maxLength: {
      type: Number,
      default: 2000
    }
  },
  data() {
    return {
      selected: null,
      error: null
    }
  },
  computed: {
    ...mapState('formStore', ['errors']),
    getTheme() {
      return `nt-textarea--${this.theme}`
    }
  },
  watch: {
    errors: {
      handler(values) {
        const { id } = this
        const error = values.find((value) => value[id]) || {}
        this.error = error[id]
      },
      deep: true
    }
  },
  created() {
    // Add to form initial values
    this.changeForm()
    // Add validators to form
    this.changeValidators({
      [this.id]: this.validators
    })
  },
  methods: {
    ...mapActions('formStore', ['changeFormData', 'changeValidators']),
    changeForm() {
      emitter.emit('changeForm', {
        [this.id]: this.selected
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .nt-textarea {
    & textarea {
      display: flex;
      width: 100%;
      font-size: 1rem;
      font-family: "Montserrat", sans-serif;
      letter-spacing: -1px;
      outline: none;
      border: 0.125rem solid $neutral-04;
      border-radius: 0.125rem;
      padding: 1.25rem;

      &::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
        font-family: "Montserrat", sans-serif;
        font-weight: 400;
        color: $neutral-01;
        opacity: 1; /* Firefox */
      }

      &:-ms-input-placeholder { /* Internet Explorer 10-11 */
        font-family: "Montserrat", sans-serif;
        font-weight: 400;
        color: $neutral-01;
      }

      &::-ms-input-placeholder { /* Microsoft Edge */
        font-family: "Montserrat", sans-serif;
        font-weight: 400;
        color: $neutral-01;
      }
    }
    &--error {
      textarea {
        border-color: $accent-orange;
      }
    }

    &--small {
      textarea {
        padding: 0.625rem;
        font-size: 1rem;
      }
    }
  }
</style>
